import { useMutation, useQueryClient } from "react-query";
import { useRouter } from "next/router";

import api from "../api";
import { QUERY_KEYS } from "../constants";

const client = api();

export default function useLogin() {
  const router = useRouter();
  const queryClient = useQueryClient();

  const { mutate: login, isLoading, isSuccess, error } = useMutation(
    (userCredentials) =>
      client.login(userCredentials.email, userCredentials.password),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEYS.USER);
        router.replace("/");
      },
    },
  );
  return { login, isLoading, isSuccess, error };
}
